import axios from "axios";
import Vue from 'vue';
import { decode, encode } from 'js-base64';
import Dexie from 'dexie';
import db from '@/db'; // senin gerçek instance yolun
var MyPlugin = {};
var fx = JSON.parse(localStorage.getItem("fx_rates_v1") || "null");
function fmt2(val) {
  return (typeof val === "number")
    ? val.toFixed(3)
    : "";
}

MyPlugin.install = function (Vue, options) {
  const request = {
    domain: "https://api.projemikro.com/",
    //domain: "http://localhost:3003/",
    donem: function () { let date = new Date(); return date.getFullYear() },

    ayar: function () {
      if (localStorage.getItem('tfxm')) {
        return JSON.parse(localStorage.getItem('tfxm'))
      }
    },
    get: function (url, obj) {
      return new Promise((resolve, reject) => {
        const ayar = request.ayar && request.ayar();
        const baseHeaders = (ayar && ayar.session && ayar.token)
          ? { session: ayar.session, token: ayar.token }
          : {};
        const headers = { ...baseHeaders, ...(obj || {}) };
        axios
          .get(this.domain + url, {
            headers: headers,
          })
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    post(url, data) { // buradaki alt function ile url yi create edebilirsin
      //console.log(data)
      return new Promise((resolve, reject) => {
        axios
          .post(this.domain + url, data, {
            headers: {
              session: request.ayar().session,
              token: request.ayar().token
            },
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            const status = error && error.response ? error.response.status : null;
            const serverMsg =
              error && error.response && error.response.data
                ? (error.response.data.message || error.response.data.errorMessage || error.response.data.msg || "")
                : "";

            if (status) {
              error.message = serverMsg || ("Tekrar Deneyiniz. " + status);
            } else {
              error.message = serverMsg || (error && error.message ? error.message : "Tekrar Deneyiniz.");
            }
            reject(error)
          });
      })
    },
    put(url, data) { // buradaki alt function ile url yi create edebilirsin
      let postObje = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { "Content-type": "application/json; charset=UTF-8" }
      }
      return new Promise((resolve, reject) => {
        axios
          .post(this.domain + url, data)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
    delete: function (url) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.domain + url)
          .then(response => (resolve(response.data)))
          .catch(error => reject(error));
      })
    },
  }

  var helper = {

    doviz: [1, fmt2(fx && fx.rates && fx.rates.USD), fmt2(fx && fx.rates && fx.rates.EUR)],

    login(username, password, securityBrowser) {
      return new Promise(function (resolve, reject) {
        let data = { kadi: username, pass: password }
        axios.post(request.domain + "crm/login", data)
          .then(res => {
            if (res) {
              if (res.data.status === 200) {
                setTimeout(() => {
                  localStorage.setItem('tfxm', JSON.stringify(res.data.data))
                  if (securityBrowser) localStorage.setItem('securityBrowser', securityBrowser)
                  resolve({ data: res.data.data, status: true })
                }, 1000);
              }
              else { reject({ data: [], status: false, msg: res.data.msg }) }
            }
            else {
              reject({ data: [], status: false, msg: "Sunucu Hatası" })
            }

          })
          .catch(err => reject({ data: [], status: false, msg: "Tekrar Deneyiniz" }))
      });
    },
    // token(arr,username,pass){
    //   let erhan = null;
    //   let sayfa = [];
    //     return new Promise ((resolve) => {
    //         request.get('sayfalistesi/'+arr.kid)
    //          .then(res => {
    //            res.results.forEach(element => {
    //              sayfa.push(parseInt(element.kodu))
    //            });
    //          })
    //           resolve(
    //             {
    //               erhan : arr.firma*8589+'wpk'+arr.kid*8848+'atc'+arr.kodu+'aNg'+encode(username)+'btc'+encode(pass),
    //               page : sayfa
    //             }
    //           )
    //     })
    // },

    async logout() {
      try {
        // LocalStorage temizle
        localStorage.removeItem('tfxm');
        localStorage.removeItem('aktifPersonel');

        // Açık bağlantıları kapat
        try { db.close(); } catch (e) { }

        // Silmeyi dene (blocked olursa kısa aralıklarla tekrar dene)
        const dbName = 'MyStockDB';
        const maxTry = 10;

        const sb = localStorage.getItem('securityBrowser');
        if (sb === null || sb === '0' || sb === 'false') {
          localStorage.removeItem('last_sync');
          localStorage.removeItem('sync_status');
          for (let i = 0; i < maxTry; i++) {
            try {
              await Dexie.delete(dbName);
              break; // başarılı
            } catch (err) {
              // blocked veya transient durumlar için
              await new Promise(r => setTimeout(r, 150));
              if (i === maxTry - 1) throw err;
            }
          }
        }


      } catch (err) {
        console.error('Logout cleanup error:', err);
      } finally {
        // Silme tamamlandıktan sonra reload
        setTimeout(() => location.replace('/'), 200);
        //console.log(localStorage.getItem('securityBrowser'))
      }
    },

    handleResponse(username, password) { // buradaki handleResponse main de helper yerine direkt bu isimle sÃ¼slÃ¼ parantezler iÃ§inde Ã§ekebilirmiyiz bir bakalÄ±m
      return new Promise(function (resolve, reject) {
        let data = { kadi: username, pass: password }
        request.post('login/', data)
          .then(res => {
            if (res.status === 200) { resolve(true) }
            else { reject(false) }
          })
          .catch(err => reject(err.message))
      });
    },
    kdvharicgoster(fiyat, kdvli, kdv) { // kdv hariç gösterimleri için
      if (kdvli == 1 && kdv > 0) {
        let kdvsiz = fiyat / (1 + (kdv / 100))
        return {
          kdvsiz: kdvsiz,
          kdv: fiyat - kdvsiz
        }
      }
      else {
        return {
          kdvsiz: fiyat,
          kdv: kdv
        }
      }
    },
    ilkharfBuyuk(str) {
      if (str) {
        return str = str.replace(/([\wöçşğüıİ])/gi,
          function (a, b) { return b.replace("I", "ı").toLowerCase() }).replace(/(^[a-zöçşğüı]|[\s|\.][a-zöçşğüı])/g,
            function (c, d) {
              return d.replace("i", "i").toUpperCase();
            });
      }
      else {
        return "Tanımsız"
      }
    },

    parabirimi(res, pb) {
      if (res) {

        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€", pb)
      }
      if (res == 0) { return 0 + " " + pb }
      else { return "?" }

    },

    tabloarama() {
      var e, t, n, a, l;
      for (e = document.getElementById("arama").value.toUpperCase(), t = document.getElementById("tablo").getElementsByTagName("tr"), l = 1; l < t.length; l++) {
        t[l].style.display = "none", n = t[l].getElementsByTagName("td");
        for (var m = 0; m < n.length; m++)
          if ((a = t[l].getElementsByTagName("td")[m]) && a.innerHTML.toUpperCase().indexOf(e) > -1) {
            t[l].style.display = "";
            break
          }
      }
    },

    groupByAdet(array, key) {
      return array.reduce((acc, item) => {
        const accAmout = acc[item[key]] || 0;
        return Object.assign(
          {}, acc, {
          [item[key]]: accAmout + 1,
        }
        )
      }
        , {})
    },

    groupByAdet2(arr) {
      let result = []
      arr.forEach(function (a) {
        if (!this[a.st]) {
          this[a.st] = { name: a.st, shape: a.ay, adet: 0 };
          result.push(this[a.st]);
        }
        this[a.st].adet += +1;
        //   this[a.color].instances += a.instances;
      }, Object.create(null));
    },
    //https://stackoverflow.com/questions/60474369/how-to-count-and-group-multiple-properties-values-in-array-of-objects
    //https://stackoverflow.com/questions/51040651/group-by-and-calculate-mean-average-of-properties-in-a-javascript-array  
    //https://stackoverflow.com/questions/51971373/group-by-count-distinct-sum-totals-from-objects-in-javascript-array   
    group2adet(arr, param2, param1) {
      //let deneme = []
      var result = arr.reduce(function (acc, obj) {
        let deneme = {}
        var g1 = acc[obj[param1]] = acc[obj[param1]] || {};
        var g2 = g1[obj[param2]] = g1[obj[param2]] || { count: 0 };
        g2.count++;
        //let deneme = {data:[g2.count++]}
        return acc;
      }, Object.create(null));
      return result;
    },
    trtgoster(uzuntarih) {
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      const d = new Date(uzuntarih);
      return d.getDate() + '-' + monthNames[d.getMonth()] + '-' + d.getFullYear();
    },
    trsaatyazdir() {
      let d = new Date();
      return d.getHours() + ':' + d.getMinutes()
    },
    piechart(array, keys) {
      let serie = new Array;
      let label = new Array;
      Object.keys(array).forEach(function (key) {
        serie.push(array[key])
        label.push(key)
      })
      return {
        series: serie,
        chartOptions: {
          chart: {
            type: 'pie',
            foreColor: '#a5a7ab',
          },
          labels: label,
          colors: ['#723ac3', "#864DD9", "#9762e6", "#a678eb"],
        }
      }
    },
    gunhesapla(t1) {
      var MS_one_day = 1000 * 60 * 60 * 24;
      var y = new Date();
      var x = new Date(t1);
      var date1 = Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()); //x
      var date2 = Date.UTC(y.getFullYear(), y.getMonth(), y.getDate()); //y
      return Math.floor((date2 - date1) / MS_one_day);
    },
    getNow() {
      const today = new Date();
      const date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      //const dateTime = date +' '+ time;
      return {
        tarih: date,
        saat: time
      }
    },
    sayfayetki: function (indexi) {
      if (localStorage.getItem('tfx')) {
        let obje = request.ayar().page
        let index = obje.indexOf(indexi);
        if (index > -1) {
          return true
        }
        else return false
      }
    },
    iskontohesap(fiyat, oran) { //iskonto düşer
      return fiyat - (fiyat * (oran / 100))
    },
    point(ckod, ana, alt, marka, guid, kelime, web, mevcut, kampanya, gruplama, orderkey, ordervalue, sayfa, yeni, sayfalama, cari_iskonto_kod, ambalaj) {
      return {
        ckod: ckod,
        cari_iskonto_kod: cari_iskonto_kod || 0,
        where: {
          anagrup: ana,
          altgrup: alt,
          marka: marka,
          guid: guid || 0,
          kelime: kelime || null,
          web: web || 0,
          mevcut: mevcut || 0,
          kampanya: kampanya || 0,
          yeni: yeni || 0,
          ambalaj: ambalaj || 0
        },
        gruplama: gruplama,
        order: {
          key: orderkey,
          value: ordervalue
        },
        sayfa: sayfa,
        sayfalama: sayfalama
      }
    },
    kdvhesap(fiyat, kdv) {
      return fiyat * (kdv / 100);
    },
    //bu üsttekinin yenisi
    kdvlimi(fiyat, kdvli, kdv) { // kdv dahil gösterimleri için
      if (kdvli == 1) {
        let kdvsiz = parseFloat(fiyat) + (parseFloat(fiyat) * (kdv / 100))
        return {
          kdvli: parseFloat(kdvsiz),
          kdv: fiyat - kdvsiz
        }
      }
      else {
        return {
          kdvli: fiyat,
          kdv: kdv
        }
      }
    },
    setFiltre() {
      const d = new Date();
      const monthNum = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      const monthName = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
      const monthInt = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];


      return {
        aylik: {
          t1: d.getFullYear() + '-' + monthNum[d.getMonth()] + '-01',
          t2: d.getFullYear() + '-' + monthNum[d.getMonth()] + '-' + d.getDate(),
          aktifAy: monthName[d.getMonth()] + ' ' + d.getFullYear(),
          sadeceay: monthName[d.getMonth()],
          calendar: d.getFullYear() + ',' + monthInt[d.getMonth()] + ',' + d.getDate()
        },
        yillik: {
          t1: d.getFullYear() + '-01-01',
          t2: d.getFullYear() + '-' + monthNum[d.getMonth()] + '-' + d.getDate(),
          aktifYil: d.getFullYear()
        },
      }
    },
    trtgosternoktali(uzuntarih) {
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      const d = new Date(uzuntarih);
      return d.getFullYear() + '.' + monthNames[d.getMonth()] + '.' + d.getDate();
    },
    sefLink(textString) {
      //console.log(textString)
      textString = textString.replace(/ /g, "_");
      textString = textString.replace(/</g, "");
      textString = textString.replace(/>/g, "");
      textString = textString.replace(/"/g, "");
      textString = textString.replace(/é/g, "");
      textString = textString.replace(/!/g, "");
      textString = textString.replace(/’/, "");
      textString = textString.replace(/£/, "");
      textString = textString.replace(/^/, "");
      textString = textString.replace(/#/, "");
      textString = textString.replace(/$/, "");
      textString = textString.replace(/\+/g, "");
      textString = textString.replace(/%/g, "");
      textString = textString.replace(/½/g, "");
      textString = textString.replace(/&/g, "");
      textString = textString.replace(/\//g, "");
      textString = textString.replace(/{/g, "");
      textString = textString.replace(/\(/g, "");
      textString = textString.replace(/\[/g, "");
      textString = textString.replace(/\)/g, "");
      textString = textString.replace(/]/g, "");
      textString = textString.replace(/=/g, "");
      textString = textString.replace(/}/g, "");
      textString = textString.replace(/\?/g, "");
      textString = textString.replace(/\*/g, "");
      textString = textString.replace(/@/g, "");
      textString = textString.replace(/€/g, "");
      textString = textString.replace(/~/g, "");
      textString = textString.replace(/æ/g, "");
      textString = textString.replace(/ß/g, "");
      textString = textString.replace(/;/g, "");
      textString = textString.replace(/,/g, "");
      textString = textString.replace(/`/g, "");
      textString = textString.replace(/|/g, "");
      textString = textString.replace(/\./g, "");
      textString = textString.replace(/:/g, "");
      textString = textString.replace(/İ/g, "i");
      textString = textString.replace(/I/g, "i");
      textString = textString.replace(/ı/g, "i");
      textString = textString.replace(/ğ/g, "g");
      textString = textString.replace(/Ğ/g, "g");
      textString = textString.replace(/ü/g, "u");
      textString = textString.replace(/Ü/g, "u");
      textString = textString.replace(/ş/g, "s");
      textString = textString.replace(/Ş/g, "s");
      textString = textString.replace(/ö/g, "o");
      textString = textString.replace(/Ö/g, "o");
      textString = textString.replace(/ç/g, "c");
      textString = textString.replace(/Ç/g, "c");
      textString = textString.replace(/B/g, "b");
      textString = textString.replace(/–/g, "-");
      textString = textString.replace(/—/g, "-");
      textString = textString.replace(/—-/g, "-");
      textString = textString.replace(/—-/g, "-");
      return textString;
    },
  }
  Vue.prototype.$request = request;
  Vue.prototype.$helper = helper
}
Vue.use(MyPlugin)
export default MyPlugin;



// WEBPACK FOOTER //
// ./src/helper.js